export default __webpack_public_path__ + "static/media/hpJamuna.ab7295fd.PNG";